import React, { useState, useEffect } from "react";
import { Stack, Text } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const METHOD_OPTIONS = [
    { label: "Call", value: "Call" },
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Email", value: "Email" },
    { label: "In Person", value: "In Person" },
];

const AddContactLogDrawer = ({ isOpen, onClose, onAdd, user }) => {
    const [formData, setFormData] = useState({
        contact_method: "",
        reason: "",
        notes: "",
        outcome: "",
        next_action: "",
        follow_up_date: "",
    });


    useEffect(() => {
        if (!isOpen) {
            setFormData({
                contact_method: "",
                reason: "",
                notes: "",
                outcome: "",
                next_action: "",
                follow_up_date: "",
            });
        }
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (!formData.contact_method || !formData.reason) {
            alert("Please fill required fields");
            return;
        }

        const payload = {
            ...formData,
            user_id: user?.user_id,
        };

        onAdd(payload);
        onClose();
    };

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={
                <Stack spacing={1}>
                    <Text fontSize="lg" fontWeight="bold">
                        Add Contact Log
                    </Text>


                    <Text fontSize="sm" color="white">
                        {user
                            ? `${user.first_name && user.last_name
                                ? `${user.first_name} ${user.last_name}`
                                : user.username || "Unknown User"
                            }${user.phone_number ? ` • ${user.phone_number}` : ""}`
                            : "No user selected"}
                    </Text>
                </Stack>
            }
            bodyContent={
                <Stack spacing={4}>

                    <ReusableInput
                        label="Contact Method"
                        name="contact_method"
                        value={formData.contact_method}
                        onChange={handleChange}
                        type="select"
                        options={METHOD_OPTIONS}
                    />

                    <ReusableInput
                        label="Reason"
                        name="reason"
                        value={formData.reason}
                        onChange={handleChange}
                    />

                    <ReusableInput
                        label="Notes"
                        name="notes"
                        value={formData.notes}
                        onChange={handleChange}
                    />

                    <ReusableInput
                        label="Outcome"
                        name="outcome"
                        value={formData.outcome}
                        onChange={handleChange}
                    />

                    <ReusableInput
                        label="Next Action"
                        name="next_action"
                        value={formData.next_action}
                        onChange={handleChange}
                    />

                    <ReusableInput
                        label="Follow Up Date"
                        name="follow_up_date"
                        type="date"
                        value={formData.follow_up_date}
                        onChange={handleChange}
                    />
                </Stack>
            }
            footerContent={
                <Stack direction="row" justify="flex-end">
                    <GradientButton onClick={onClose} height="37px">
                        Cancel
                    </GradientButton>

                    <GradientButton onClick={handleSubmit} height="37px">
                        Save Log
                    </GradientButton>
                </Stack>
            }
        />
    );
};

export default AddContactLogDrawer;